import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { Grid, Button, DataTable, DialogOffice, OfficeList, OfficeData, makeStyles, Typography } from "../../../../../";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      padding: "4px 25px"
    },
    divider: {
      height: "4px"
    },
    mr10: {
      "margin-right": "10px"
    },
    mr30: {
      margin: "30px"
    },
    header: {
      display: "flex",
      "align-items": "center",
      "justify-content": "space-between"
    },
    table: {
      display: "flex",
      "align-items": "top",
      "justify-content": "space-around"
    },
    charts: {
      display: "flex",
      "justify-content": "space-between",
      padding: "25px"
    },
    fcolumn: {
      "flex-direction": "column",
      "min-width": "425px"
    },
    card: {
      minHeight: "200px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    content: {
      width: "80%",
      "text-align": "center",
      margin: "20px"
    },
    cardText: {
      background: "#b7b6b682",
      width: "100%",
      minHeight: "200px",
      alignItems: "center",
      justifyContent: "center",
      display: "flex",
      borderRadius: "0 4px 4px 0",
      "flex-direction": "column",
      padding: "15px",
      "text-align": "center"
    },
    box: {
      display: "flex",
      "align-items": "center",
      "border-radius": "4px",
      border: "1px solid #7d7d7d"
    }
  };
});

var Office = function Office(props) {
  // console.log("Office props", props);
  var data = props.data,
      columns = props.columns,
      title = props.title,
      options = props.options,
      createOfficeSubscription = props.createOfficeSubscription,
      editOfficeSubscription = props.editOfficeSubscription,
      language = props.language,
      dashboard = props.dashboard,
      plans = props.plans,
      products = props.products,
      clients = props.clients,
      translation = props.translation;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openAdd = _useState2[0],
      setOpenAdd = _useState2[1];

  var classes = useStyles();

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openEdit = _useState4[0],
      setEditOpen = _useState4[1];

  var _useState5 = useState({}),
      _useState6 = _slicedToArray(_useState5, 2),
      selected = _useState6[0],
      setSelected = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      officeSubscriptions = _useState8[0],
      setOfficeSubscriptions = _useState8[1];

  var _useState9 = useState("ES"),
      _useState10 = _slicedToArray(_useState9, 2),
      country = _useState10[0],
      setCountry = _useState10[1]; // console.log('data', data)


  useEffect(function () {
    setOfficeSubscriptions(data && _toConsumableArray(data).filter(function (office) {
      return office.country === "ES";
    })
    /* .map((subscription) => {
          return { ...subscription, users: subscription.users.length };
      })*/
    ); // console.log('first useeffect', subscriptions)
  }, [data]);
  useEffect(function () {
    country === "all" ? setOfficeSubscriptions(_toConsumableArray(data))
    /* .map((subscription) => {
         return { ...subscription, users: subscription.users.length };
     }) */
    : setOfficeSubscriptions(_toConsumableArray(data).filter(function (office) {
      return office.country === country;
    })
    /* .map((subscription) => {
        return { ...subscription, users: subscription.users.length };
    }) */
    ); // console.log('country use effect', franchises)
  }, [country]);

  var handleDialogAdd = function handleDialogAdd() {
    setOpenAdd(!openAdd);
  };

  var filterData = function filterData(country) {
    return setCountry(country);
  }; // eslint-disable-next-line no-unused-expressions
  // columns
  //     ? (columns.find(column=>column.name==='options')options = {
  //         filter: false,
  //         sort: false,
  //         viewColumns: false,
  //         empty: true,
  //         label: false,
  //         customBodyRender: (value, tableMeta, updateValue) => <Link to={`/subscriptions/${tableMeta.rowData[0]}`} style={{ color: '#fff' }}>
  //             <RemoveRedEye />
  //         </Link>
  //     })
  //     : null;


  var handleDialogEdit = function handleDialogEdit(id) {
    if (!openEdit) {
      var franchise = data.find(function (franchise) {
        return franchise._id === id;
      });
      setSelected(franchise);
    } else {
      setSelected({});
    }

    setEditOpen(!openEdit);
  };

  return [/*#__PURE__*/React.createElement(DialogOffice, {
    open: openAdd,
    plans: plans,
    products: products,
    clients: clients,
    onClose: handleDialogAdd,
    variant: "add",
    createOfficeSubscription: createOfficeSubscription
  }), /*#__PURE__*/React.createElement(DialogOffice, {
    open: openEdit,
    plans: plans,
    products: products,
    clients: clients,
    onClose: handleDialogEdit,
    variant: "edit",
    editOfficeSubscription: editOfficeSubscription,
    data: selected
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.header
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      color: "#fafafa"
    }
  }, translation ? translation.title : "Office Subscriptions"), /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    className: classes.mr30,
    color: "primary",
    variant: "outlined",
    onClick: handleDialogAdd
  }, "+ Add Office Subscription")), /*#__PURE__*/React.createElement(OfficeData, {
    dashboard: dashboard,
    country: country
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.table
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3,
    className: classes.editor
  }, /*#__PURE__*/React.createElement(OfficeList, {
    officeSubscriptions: data,
    filterData: filterData
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 9,
    className: classes.editor
  }, /*#__PURE__*/React.createElement(DataTable, {
    key: language + "_subscriptions",
    columns: columns,
    title: title,
    options: options,
    data: officeSubscriptions
  })))];
};

export default Office;